export const getObj = (name) => {
  let obj = JSON.parse(window.localStorage.getItem(name));
  if (!obj) {
    obj = {};
  }
  return obj;
};

export const getSessionObj = (name) => {
  let obj = JSON.parse(window.sessionStorage.getItem(name));
  if (!obj) {
    obj = {};
  }
  return obj;
};

export const setObj = (name, obj) => {
  try {
    const seen = new Set();
    const serialized = JSON.stringify(obj, (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          return undefined; // This will remove the circular reference
        }
        seen.add(value);
      }
      return value;
    });
    window.localStorage.setItem(name, serialized);
  } catch (error) {
    console.error('Failed to store object:', error);
  }
};

export const setSessionObj = (name, obj) => {
  try {
    const seen = new Set();
    const serialized = JSON.stringify(obj, (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          return undefined; // This will remove the circular reference
        }
        seen.add(value);
      }
      return value;
    });
    window.sessionStorage.setItem(name, serialized);
  } catch (error) {
    console.error('Failed to store object in session:', error);
  }
};

export const removeFromObj = (name, key) => {
  const obj = getObj(name);
  if (obj === null || !(key in obj)) return null;

  delete obj[key];

  return setObj(name, obj);
};

export const removeFromSessionObj = (name, key) => {
  const obj = getSessionObj(name);
  if (obj === null || !(key in obj)) return null;

  delete obj[key];

  return setSessionObj(name, obj);
};

export const clearStorage = (includeEnv = false) => {
  Object.keys(window.localStorage).forEach((key) => {
    if (!key.startsWith('env') || includeEnv) {
      window.localStorage.removeItem(key);
    }
  });
};

export const clearSessionStorage = () => window.sessionStorage.clear();

export const removeObj = (name) => window.localStorage.removeItem(name);

export const removeSessionObj = (name) => window.sessionStorage.removeItem(name);

export const objExists = (name) => {
  const obj = window.localStorage[name];
  return !!obj;
};

export const sessionObjExists = (name) => {
  const obj = window.sessionStorage[name];
  return !!obj;
};

export const logObj = (file, name = 'object') => {
  console.log('\n', name, ':', `${JSON.stringify(file, null, '    ')}\n\n`);
};

function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item) && item !== null;
}

function mergeRecursive(target, source) {
  const merged = { ...target };

  Object.keys(source).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (isObject(target[key]) && isObject(source[key])) {
        merged[key] = mergeRecursive(target[key], source[key]);
      } else {
        merged[key] = source[key];
      }
    }
  });

  return merged;
}

export const updateObj = (name, obj) => {
  const old = getObj(name);
  if (old === undefined) {
    return setObj(name, obj);
  }
  const combined = mergeRecursive(old, obj);

  return setObj(name, combined);
};

export const updateSessionObj = (name, obj) => {
  const existingObj = getSessionObj(name);
  if (isObject(obj)) {
    const merged = mergeRecursive(existingObj, obj);
    setSessionObj(name, merged);
  } else {
    setSessionObj(name, obj);
  }
};
